import { CheckIcon, ChevronDownIcon, ChevronUpIcon } from '@radix-ui/react-icons'
import classnames from 'classnames'
import { Select } from 'radix-ui'
import * as React from 'react'
import styles from './styles.module.css'

interface SelectProps {
  arialabel: string
  placeholder: string
  options: string[]
  onValueChange?: (value: string) => void
  value?: string
  label?: string
  id?: string
  className?: string
  error?: string | null // Add error prop
  disabled?: boolean
}

const SelectRadix = ({ arialabel, placeholder, options, onValueChange, value, label, id, className, error, disabled }: SelectProps) => (
  <fieldset className={`${styles.fieldset} ${className || ''}`}>
    {label && (
      <label className={styles.label} htmlFor={id}>
        {label}
      </label>
    )}
    <Select.Root onValueChange={onValueChange} value={value}>
      <Select.Trigger
        className={classnames(
          styles.Trigger,
          error ? styles.TriggerError : '', // Add error styling class
        )}
        aria-label={arialabel}
        id={id}
        disabled={disabled}
      >
        <Select.Value placeholder={placeholder} />
        <Select.Icon className={styles.Icon}>
          <ChevronDownIcon />
        </Select.Icon>
      </Select.Trigger>
      <Select.Portal>
        <Select.Content className={styles.Content}>
          <Select.ScrollUpButton className={styles.ScrollButton}>
            <ChevronUpIcon />
          </Select.ScrollUpButton>
          <Select.Viewport className={styles.Viewport}>
            <Select.Group>
              {options?.map((item) => (
                <SelectItem key={item} value={item}>
                  {item}
                </SelectItem>
              ))}
            </Select.Group>
          </Select.Viewport>
          <Select.ScrollDownButton className={styles.ScrollButton}>
            <ChevronDownIcon />
          </Select.ScrollDownButton>
        </Select.Content>
      </Select.Portal>
    </Select.Root>
    {error && <p className={styles.errorText}>{error}</p>}
  </fieldset>
)

interface SelectItemProps extends React.ComponentProps<typeof Select.Item> {
  children: React.ReactNode
  className?: string
}

const SelectItem = React.forwardRef<HTMLDivElement, SelectItemProps>(({ children, className, ...props }, forwardedRef) => {
  return (
    <Select.Item className={classnames(styles.Item, className)} {...props} ref={forwardedRef}>
      <Select.ItemText>{children}</Select.ItemText>
      <Select.ItemIndicator className={styles.ItemIndicator}>
        <CheckIcon />
      </Select.ItemIndicator>
    </Select.Item>
  )
})

export default SelectRadix
